import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Popup } from 'semantic-ui-react';

class ReactTableHeaderText extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { title, filter } = this.props;

    return (
      <div className={filter ? 'header-text-area filter' : 'header-text-area'}>
        <Popup
          position="top center"
          trigger={<div className="header-asc" />}
          content={defineMessages(formatMessage({ id: 'TableHeader_1', defaultMessage: '오름차순 정렬' }))}
        />
        <Popup
          position="top center"
          trigger={<div className="header-desc" />}
          content={defineMessages(formatMessage({ id: 'TableHeader_2', defaultMessage: '내림차순 정렬' }))}
        />
        <div className="img-ordering" />
        {title}
        {filter}
      </div>
    );
  }
}

export default injectIntl(ReactTableHeaderText);



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTableHeaderText.js